import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, TextField, Typography } from '@material-ui/core'

import { Label } from 'components'
import { EvidenceDocumentsTable } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

const EvidenceSection = ({ attachments = null }) => {
  const { control, errors } = useFormContext()
  const { isShow } = useThirdPartyManagementStepper()

  return (
    <Box display="flex" flexDirection="column" gridGap={8}>
      <Typography variant="h6">Evidências</Typography>
      <Label
        description="Evidência da implantação (o que foi feito)"
        marginTopChildren={0}
      >
        <Controller
          as={
            <TextField
              variant="outlined"
              multiline
              minRows={4}
              maxRows={12}
              error={!!errors?.justify}
              helperText={errors?.justify?.message}
              fullWidth
              disabled={isShow}
            />
          }
          control={control}
          name="justify"
        />
      </Label>
      <Box mt={2}>
        <EvidenceDocumentsTable
          controlName="evidences"
          attachments={attachments}
        />
      </Box>
    </Box>
  )
}

EvidenceSection.propTypes = {
  attachments: PropTypes.array,
}

export default EvidenceSection
